import React from 'react'
import ListBox from 'components/ListBox'
import styled from 'react-emotion'
import { color } from 'stylist'

const EmptyMessage = styled.h6`
  && {
    color: ${color('cadet')};
    margin-bottom: 0;
    text-align: center;
  }
`

const EmptyListItem = ({ children }) => (
  <ListBox.Item>
    <EmptyMessage>{children}</EmptyMessage>
  </ListBox.Item>
)

export default EmptyListItem



// WEBPACK FOOTER //
// ./src/routes/admin/features/components/EmptyListItem.js